/**
 * @file useInterval
 * @author dailin01
 */

import {useEffect, useRef} from 'react';
import {isNumber} from 'lodash';

export type Callback = (...args: any) => any;

export default (callback: Callback, interval?: number, abort?: boolean): void => {
    const savedCallback = useRef(callback);

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        const tick = () => savedCallback.current();
        if (isNumber(interval) && !abort) {
            const id = setInterval(tick, interval);
            return () => clearInterval(id);
        }
    }, [interval, abort]);
};